import type { FeatureItem } from '~/lib/feature-items';

function InfoCard({ feature, index }: { feature: FeatureItem; index: number }) {
  return (
    <li className="relative">
      <article className="relative min-h-[104px] p-3 pr-10 sm:min-h-[124px] sm:p-4 sm:pr-14">
        <span className="absolute top-1 right-2 text-base leading-none font-extralight text-slate-300 sm:top-2 sm:right-4 sm:text-lg dark:text-slate-600">
          {String(index + 1).padStart(2, '0')}
        </span>

        <p className="font-heading relative z-10 text-lg leading-tight font-semibold break-words text-slate-700 underline decoration-green-400/70 underline-offset-4 sm:text-xl dark:text-slate-100">
          {feature.title}
        </p>

        <p className="relative z-10 mt-2 text-sm leading-relaxed break-words text-slate-500 sm:mt-4 dark:text-slate-300">
          {feature.description}
        </p>
      </article>
    </li>
  );
}

export function FeaturesList({ items }: { items: FeatureItem[] }) {
  return (
    <ul className="mx-auto flex w-full flex-col divide-y divide-dashed divide-slate-200 py-1 dark:divide-slate-800">
      {items.map((feature, i) => (
        <InfoCard key={feature.title} feature={feature} index={i} />
      ))}
    </ul>
  );
}
